export default __webpack_public_path__ + "assets/安全データシート.0892ecc7.pdf";